import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { PageWrap, FadeIn } from '../components/Section';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', company: '', service: '', message: '' });
  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });
  const handleSubmit = e => {
    e.preventDefault();
    alert('Thank you for your inquiry. Our team will contact you within 24 hours.');
    setForm({ name: '', email: '', phone: '', company: '', service: '', message: '' });
  };

  const inputStyle = { width: '100%', padding: '12px 16px', border: '1px solid var(--border)', borderRadius: 6, fontFamily: "'Inter',sans-serif", fontSize: '0.9rem', color: 'var(--text)', background: 'var(--cream)', outline: 'none', transition: 'border-color 0.2s' };

  return (
    <PageWrap>
      <section style={{ padding: '160px 0 80px', background: 'var(--warm)' }}>
        <div className="container">
          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
            <p style={{ fontSize: '0.82rem', fontWeight: 600, color: 'var(--primary)', letterSpacing: 1.5, textTransform: 'uppercase', marginBottom: 16 }}>Contact Us</p>
            <h1 style={{ fontSize: 'clamp(2rem, 4vw, 3rem)', fontWeight: 700, marginBottom: 20 }}>
              Get In Touch<br /><span style={{ color: 'var(--primary-light)' }}>With Our Team</span>
            </h1>
            <p style={{ fontSize: '1.08rem', color: 'var(--text-mid)', maxWidth: 550, lineHeight: 1.7 }}>
              Whether you need soil testing, material analysis, or equipment — our team is ready to discuss your project requirements.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Info Cards */}
      <section style={{ padding: '48px 0', background: 'var(--white)' }}>
        <div className="container">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 20 }}>
            {[
              { icon: '📍', title: 'Visit Our Lab', lines: ['H. No. 61, Narayan Nagar', 'Hoshangabad Road, Bhopal', 'MP – 462043'], note: 'Opposite Barkatullah University' },
              { icon: '📞', title: 'Call Us', lines: ['+91 9926159598', '+91 7067434734'], note: 'Mon – Sat, 9 AM – 6 PM' },
              { icon: '✉️', title: 'Email', lines: ['hiconresurch@gmail.com'], note: 'Response within 24 hours' },
            ].map(c => (
              <FadeIn key={c.title}>
                <div style={{ padding: 28, background: 'var(--cream)', border: '1px solid var(--border)', borderRadius: 'var(--radius)', textAlign: 'center' }}>
                  <span style={{ fontSize: '1.8rem', display: 'block', marginBottom: 14 }}>{c.icon}</span>
                  <h4 style={{ fontSize: '1rem', marginBottom: 10 }}>{c.title}</h4>
                  {c.lines.map(l => <p key={l} style={{ fontSize: '0.88rem', color: 'var(--text-mid)', lineHeight: 1.5 }}>{l}</p>)}
                  <span style={{ display: 'block', marginTop: 10, fontSize: '0.78rem', color: 'var(--text-light)' }}>{c.note}</span>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      {/* Form */}
      <section style={{ padding: '100px 0', background: 'var(--cream)' }}>
        <div className="container" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 60, alignItems: 'start' }}>
          <FadeIn>
            <h2 style={{ fontSize: '2.2rem', marginBottom: 16 }}>Send an Inquiry</h2>
            <p style={{ fontSize: '0.95rem', color: 'var(--text-mid)', lineHeight: 1.6, marginBottom: 32 }}>
              Fill out the form and our technical team will review your requirements. For urgent requests, call us directly.
            </p>
            <h4 style={{ fontSize: '0.95rem', marginBottom: 12 }}>Services We Offer</h4>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 32 }}>
              {['Geotechnical Site Investigation', 'Soil Testing (SBC, CBR, SPT)', 'Concrete & Cement Testing', 'Steel & Aggregate Testing', 'Non-Destructive Testing', 'Testing Equipment Supply', 'Engineering Consultancy'].map(s => (
                <li key={s} style={{ fontSize: '0.88rem', color: 'var(--text-mid)', paddingLeft: 16, position: 'relative' }}>
                  <span style={{ position: 'absolute', left: 0, color: 'var(--primary)' }}>→</span>{s}
                </li>
              ))}
            </ul>
            <a href="https://wa.me/917067434734" target="_blank" rel="noopener noreferrer" className="btn btn-primary">💬 Chat on WhatsApp</a>
          </FadeIn>

          <FadeIn delay={0.2}>
            <form onSubmit={handleSubmit} style={{ background: 'white', border: '1px solid var(--border)', borderRadius: 'var(--radius)', padding: 36 }}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
                <div>
                  <label style={{ display: 'block', fontSize: '0.83rem', fontWeight: 500, color: 'var(--text-mid)', marginBottom: 6 }}>Full Name *</label>
                  <input name="name" value={form.name} onChange={handleChange} required placeholder="Your name" style={inputStyle} onFocus={e => e.target.style.borderColor = 'var(--primary)'} onBlur={e => e.target.style.borderColor = 'var(--border)'} />
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: '0.83rem', fontWeight: 500, color: 'var(--text-mid)', marginBottom: 6 }}>Email *</label>
                  <input name="email" type="email" value={form.email} onChange={handleChange} required placeholder="your@email.com" style={inputStyle} onFocus={e => e.target.style.borderColor = 'var(--primary)'} onBlur={e => e.target.style.borderColor = 'var(--border)'} />
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
                <div>
                  <label style={{ display: 'block', fontSize: '0.83rem', fontWeight: 500, color: 'var(--text-mid)', marginBottom: 6 }}>Phone *</label>
                  <input name="phone" type="tel" value={form.phone} onChange={handleChange} required placeholder="+91 XXXXX XXXXX" style={inputStyle} onFocus={e => e.target.style.borderColor = 'var(--primary)'} onBlur={e => e.target.style.borderColor = 'var(--border)'} />
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: '0.83rem', fontWeight: 500, color: 'var(--text-mid)', marginBottom: 6 }}>Company</label>
                  <input name="company" value={form.company} onChange={handleChange} placeholder="Company name" style={inputStyle} onFocus={e => e.target.style.borderColor = 'var(--primary)'} onBlur={e => e.target.style.borderColor = 'var(--border)'} />
                </div>
              </div>
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: 'block', fontSize: '0.83rem', fontWeight: 500, color: 'var(--text-mid)', marginBottom: 6 }}>Service Required *</label>
                <select name="service" value={form.service} onChange={handleChange} required style={inputStyle} onFocus={e => e.target.style.borderColor = 'var(--primary)'} onBlur={e => e.target.style.borderColor = 'var(--border)'}>
                  <option value="">Select a service</option>
                  <option value="soil">Soil Testing & Investigation</option>
                  <option value="sbc">SBC / Bearing Capacity</option>
                  <option value="cbr">CBR Testing</option>
                  <option value="concrete">Concrete & Cement Testing</option>
                  <option value="steel">Steel Testing</option>
                  <option value="ndt">Non-Destructive Testing</option>
                  <option value="equipment">Equipment Purchase</option>
                  <option value="consultancy">Engineering Consultancy</option>
                  <option value="other">Other</option>
                </select>
              </div>
              <div style={{ marginBottom: 24 }}>
                <label style={{ display: 'block', fontSize: '0.83rem', fontWeight: 500, color: 'var(--text-mid)', marginBottom: 6 }}>Project Details</label>
                <textarea name="message" value={form.message} onChange={handleChange} rows="4" placeholder="Describe requirements, location, timeline..." style={{ ...inputStyle, resize: 'vertical' }} onFocus={e => e.target.style.borderColor = 'var(--primary)'} onBlur={e => e.target.style.borderColor = 'var(--border)'} />
              </div>
              <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', padding: 16, fontSize: '0.95rem' }}>Submit Inquiry</button>
            </form>
          </FadeIn>
        </div>
      </section>

      {/* Map */}
      <section style={{ padding: '0 0 100px', background: 'var(--cream)' }}>
        <div className="container">
          <FadeIn>
            <div style={{ borderRadius: 'var(--radius)', overflow: 'hidden', boxShadow: 'var(--shadow)' }}>
              <iframe
                title="Hicon Testing Lab Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3666.5!2d77.4502!3d23.2001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjPCsDEyJzAwLjQiTiA3N8KwMjcnMDAuNyJF!5e0!3m2!1sen!2sin!4v1234567890"
                width="100%"
                height="380"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>
          </FadeIn>
        </div>
      </section>
    </PageWrap>
  );
}
